
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AppDispatch, RootState } from '../../Store';

import styles from './landingpage.module.scss';
import { classNames } from 'primereact/utils';
import Footer from '../footer/Footer';

export default function LandingPageAnonymous() {

    //const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.authSlice.auth);

    useEffect(() => {
    }, [])


    return (
        <>
            <div className={classNames(styles.landingpageHeroContainer)}>
                <h3 className={classNames(styles.landingpageHeroHeadline)}>{t('deTranslation.landingPage.heroHeadline')}</h3>
                <div className={(!auth.isAuthenticated) ? classNames(styles.landingpageContentContainer) : ""}>
                    <Footer />
                </div>
            </div >
        </>
    );
}
